import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-berry-500/30 bg-catering-berry-100 px-3 py-2 text-sm text-catering-berry-600" }

import { computed } from 'vue'

const FALLBACK = 'Sorry — I ran into a problem. Please try again.'


export default {
  __name: 'BotError',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props

const isCodeLike = message => typeof message === 'string' && /^[a-z0-9_]+$/.test(message.trim())

const displayMessage = computed(() => {
  const message = props.block?.message
  if (!message || isCodeLike(message)) return FALLBACK
  return message
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(displayMessage.value), 1))
}
}

}